import { coreAppReducer } from '@bubbletea/core';
import userReducer from './userSlice';
import appReducer from './appSlice';
import productsReducer from './productsSlice';
import window from './windowSlice';

const customReducers = {
  user: userReducer,
  coreApp: coreAppReducer,
  app: appReducer,
  products: productsReducer,
  windowVars: window
};

export type CustomReducers = typeof customReducers;

export default customReducers;
